/**
 * @date: 12/7/20
 * @author: Yan Wang <ywang@max.md>
 * @copy: (C) Copyright 2020 MaxMD Corporation, All Rights Reserved.
 *
 */
import React, {useState, useEffect} from 'react';
import {Button} from "@mui/material";
import {Refresh, Search} from "@mui/icons-material";
import {getQueryString} from "../utils/http-helpers";
import TextField from '@mui/material/TextField';
import makeStyles from '@mui/styles/makeStyles';
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import states from '../utils/states.json';

const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
            width: '25ch',
        },
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));

export default function OrganizationSearchPanel(props){
    const classes = useStyles();
    const onQueryStringChanged = props.onQueryStringChanged;
    const onRefresh = props.onRefresh;

    const [params, setParams] = useState({});
    const [queryString, setQueryString] = useState("");

    useEffect(() => {
        console.log('useEffect, queryString updated: ', queryString);
        onQueryStringChanged(queryString);
    }, [queryString]);

    const search = () => {
        setQueryString(getQueryString(params));
    }
    const refresh = () => {
        onRefresh( new Date().getTime() );
    }
    const handleFormFieldChanged = (name, value) => {
        // params[name] = value;
        const newParams = {...params};
        newParams[name] = value;
        console.log('newParams', newParams);
        setParams(newParams);
    }
    const handleResetForm = () => {
        setParams({})
        setQueryString(getQueryString({}));
    }
    const handleFormKeypress = (e) => {
        if (e.key === "Enter"){
            search();
        }
    }

    console.log('params', params);
    return (<form className={classes.root} noValidate autoComplete="off" onSubmit={(e) => e.preventDefault()}>
        <div>
            <TextField  label="Name" type="search" value={params.nameLike || ""}
                       onKeyPress={handleFormKeypress} onChange={(e) => handleFormFieldChanged('nameLike',e.target.value) } />
            <TextField  label="Direct Domain" type="search" value={params.directDomainLike || ""}
                       onKeyPress={handleFormKeypress} onChange={(e) => handleFormFieldChanged('directDomainLike',e.target.value) } />

            <FormControl className={classes.formControl}>
                <InputLabel id="select-state">State</InputLabel>
                <Select
                    labelId="select-state" value={params.state || ""}
                    onKeyPress={handleFormKeypress} onChange={(e) => handleFormFieldChanged('state',e.target.value) }
                >
                    <MenuItem value=''> -- ALL -- </MenuItem>
                    {states.map( item => <MenuItem key={item.abbreviation} value={item.abbreviation}>{item.abbreviation} - {item.name}</MenuItem>)}
                </Select>
            </FormControl>


            <TextField  label="City" type="search" value={params.city || ""}
                        onKeyPress={handleFormKeypress} onChange={(e) => handleFormFieldChanged('city',e.target.value) } />
            <TextField  label="Zipcode (5 digits)" type="search" value={params.zip5 || ""}
                        onKeyPress={handleFormKeypress} onChange={(e) => handleFormFieldChanged('zip5',e.target.value) } />

        </div>
        <div className='cert-search-actions'>
            <Button variant="contained" color={"primary"} onClick={() => search()} > <Search /> Search </Button>
            <Button variant={"outlined"} color={"primary"} onClick={() => refresh()} > <Refresh /> Refresh </Button>
            <Button variant={"outlined"} color={"primary"} onClick={() => handleResetForm() } > Reset </Button>
        </div>
    </form>);
}
